import { FormattedMessage } from 'react-intl'

import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'

const ShowMore = () => {
  return (
    <Stack spacing={1} sx={{ pt: { xs: 6, md: 5 }, pb: 7.75 }}>
      <Text variant="body1" component="h4" sx={{ fontWeight: 500 }}>
        <FormattedMessage defaultMessage="ifndautoparts - The Ultimate Car Parts Marketplace" />
      </Text>

      <Text variant="subtitle1" component="p" color="text.third">
        <FormattedMessage defaultMessage="Welcome to ifndautoparts, the online marketplace for car parts, where enthusiasts, mechanics, and part suppliers connect to trade OEM, aftermarket, and rare components with ease. From classic car parts to performance upgrades and everyday essentials, our platform makes buying and selling auto parts simple, secure, and hassle-free." />
      </Text>

      <Text variant="subtitle1" component="p" color="text.third">
        <FormattedMessage defaultMessage="With thousands of listings across all vehicle categories, finding the right part is fast and easy. Verified sellers provide clear photos, accurate descriptions, and seamless transactions. Secure payments, trusted delivery, and Click & Collect across the UK ensure a smooth shopping experience." />
      </Text>
    </Stack>
  )
}

export default ShowMore
